import React from "react";
import {useState,useEffect} from "react";
import axiosInstance from '../AxiosInstance';

const TestPage = () => {

    const fetchInfo = async() => {
        try {
            const res = await axiosInstance.post(`/overview/2`, { user: { id: 5 } });
            console.log(res);
        } catch (e) {
            console.error('TestPage fetch error:', e);
        }
    }
    useEffect(()=>{
        fetchInfo();

    },[])
    return(
        <div>Hello World!</div>
    )
}
export default TestPage;
